module.exports = __webpack_public_path__ + "static/media/Reservation-04.52c0cac0.svg";